export function enumToSelect_filter() {
    "ngInject"
    return (value, name) => {
        let keys = [];
        for (var enumMember in value) {
            if (!isNaN(parseInt(enumMember, 10))) {
                keys.push({ key: enumMember, value: value[enumMember] });
            }
        }
        return keys;
    }
}



// WEBPACK FOOTER //
// ./src/filters/enumToSelect/enumToSelect.ts